import { InitGitError } from '../errors/init.git-error';
import type { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import type { FSAction } from './actions.enum';

export interface FSInitAction extends WorkerAction {
  type: FSAction.Init;
  params: { repoDir: string; userName: string; userEmail: string };
}

export async function FSInitActionFn({ fs, params, idbfs, util }: WorkerFnParams<FSInitAction>): Promise<void> {
  const { repoDir, userName, userEmail } = params;
  fs.chdir('/');

  try {
    util.mkdirP(repoDir);
  } catch (err) {
    console.warn(`[WasmGit]: could not create folder "/${repoDir}"`, err);
  }

  try {
    fs.mount(idbfs, {}, repoDir);
  } catch (err) {
    console.warn(`[WasmGit]: could not mount folder "/${repoDir}"`, err);
  }

  try {
    await util.syncfs(true);
  } catch (err) {
    console.error(`[WasmGit]: could not sync folder "/${repoDir}"`, err);
    throw new InitGitError(repoDir);
  }

  fs.chdir(repoDir);

  fs.writeFile(
    '/home/web_user/.gitconfig',
    `[user]
        name = ${userName}
        email = ${userEmail}`,
  );
}
